import { digObject } from '@domain-group/javascript-utils'

import type { UseFormPayload } from '@domain-group/react-hooks'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import useAgencyPortals from '@hooks/useAgencyPortals'
import useSelector from '@hooks/useSelector'

import type { EntitiesState } from '@redux/entities'

import type { AgencyPortalModel, CampaignModel } from '@models/types'

type HandleSetPortalParams = {
  data: object,
  filteredAgencyPortals: AgencyPortalModel[],
  portalId: number,
  portals: EntitiesState['portals'],
  setEntityState: UseFormPayload['setEntityState'],
}

const handleSetPortal = (params: HandleSetPortalParams) => {
  const {
    data, filteredAgencyPortals, portalId, portals, setEntityState,
  } = params

  const portal = portals[portalId] || {}

  const selectedAgencyPortal = filteredAgencyPortals.find(
    agencyPortal => agencyPortal.portal_id === portalId,
  )

  const updatedData = {
    ...data,
    portal: {
      // @ts-expect-error TS2339
      ...data.portal,
      id: portal.id,
      title: portal.title,
    },
    agent_id: selectedAgencyPortal?.identity_code,
  }

  setEntityState({ data: updatedData })
}

interface CampaignPortalSettingsProps {
  campaign: CampaignModel,
  campaignFormPayload: UseFormPayload,
}

const CampaignPortalSettings = (props: CampaignPortalSettingsProps) => {
  const { campaign, campaignFormPayload } = props

  const {
    entityState,
    handlers,
    setEntityState,
  } = campaignFormPayload

  const data = digObject(entityState, 'data', {})
  const {
    agent_id,
    outgoing_id,
    portal,
    unique_id,
  } = data

  const portalId = portal?.id

  const agencyPortalsPayload = useAgencyPortals({
    filters: { agency_id: campaign.agency_id },
    performHttpRequests: !!campaign.agency_id,
  })

  const {
    filteredAgencyPortals,
  } = agencyPortalsPayload

  const { portals } = useSelector(reduxState => reduxState.entities)

  return (
    <DashboardModule title="Portal Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Incoming Portal">
            <select
              onChange={e => handleSetPortal({
                data,
                filteredAgencyPortals,
                portalId: Number(e.target.value),
                portals,
                setEntityState,
              })}
              value={portalId}
            >
              <option value="">No Portal Set</option>
              {filteredAgencyPortals.map((agencyPortal: AgencyPortalModel) => {
                const filteredPortal = portals[agencyPortal.portal_id] || {}

                return (
                  <option key={`Portal${filteredPortal.id}`} value={filteredPortal.id}>
                    {filteredPortal.title}
                  </option>
                )
              })}
            </select>
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Incoming Agent ID" marginTop={['large', 0]}>
            <input
              name="data.agent_id"
              value={agent_id}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Incoming Unique ID">
            <input
              name="data.unique_id"
              value={unique_id}
              type="text"
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Outgoing Unique ID" marginTop={['large', 0]}>
            <input
              name="data.outgoing_id"
              value={outgoing_id}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default CampaignPortalSettings
